import { Camada } from '../types/camada.types';
import { Projeto } from '../types/projeto.types';

const DEFAULT_HYDRATION_CHUNK = 250;

// If p.projetosCamadas.length <= 1, this function does nothing.
// If p.projetosCamadas.length > 1, this fuction iterates over p
// .projetosCamadas starting from index 1 and, if a string is
// encountered, it's replaced by an object present in the
// p.projetosCamadas[0].projeto.projetosCamadas array whose @id
// is equal to it.
export function resolveProjetoCamadas(p: Projeto) {
  if (!p?.projetosCamadas || p.projetosCamadas.length <= 1) {
    return;
  }

  const baseCamadas = p.projetosCamadas[0]?.projeto?.projetosCamadas;
  if (!Array.isArray(baseCamadas) || !baseCamadas.length) {
    return;
  }

  const lookup = new Map<string, Camada>();
  baseCamadas.forEach((camada) => {
    if (!camada || typeof camada !== 'object') {
      return;
    }
    const camadaId = (camada as any)['@id'];
    if (typeof camadaId === 'string') {
      lookup.set(camadaId, camada as Camada);
    }
  });

  if (!lookup.size) {
    return;
  }

  p.projetosCamadas.forEach((camada, index) => {
    if (index === 0 || typeof camada !== 'string') {
      return;
    }
    const resolved = lookup.get(camada);
    if (resolved) {
      p.projetosCamadas[index] = resolved;
    }
  });
}

export function hydrateProjectsCamadas(
  projects: Projeto[],
  chunkSize = DEFAULT_HYDRATION_CHUNK
): Promise<Projeto[]> {
  return new Promise((resolve) => {
    if (!projects || !projects.length) {
      resolve(projects ?? []);
      return;
    }

    const normalizedChunkSize =
      typeof chunkSize === 'number' && chunkSize > 0 ? Math.floor(chunkSize) : DEFAULT_HYDRATION_CHUNK;
    const total = projects.length;
    let index = 0;

    const processChunk = () => {
      const limit = Math.min(index + normalizedChunkSize, total);
      for (; index < limit; index++) {
        resolveProjetoCamadas(projects[index]);
      }

      if (index < total) {
        setTimeout(processChunk, 0);
      } else {
        resolve(projects);
      }
    };

    processChunk();
  });
}
